import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Award, Droplets } from 'lucide-react';
export function About() {
  return <section id="remodelaciones" className="py-20 bg-white" data-id="element-15">
      <div className="container mx-auto px-4 md:px-6" data-id="element-16">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-17">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative" data-id="element-18">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-19">
              <img src="https://i.imgur.com/9SEoLu1.jpeg" alt="Trabajo finalizado por Innova Pools" className="w-full h-full object-cover" data-id="element-20" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900/60 to-transparent" data-id="element-21"></div>
              <div className="absolute bottom-6 left-6 right-6 text-white" data-id="element-22">
                <p className="font-display font-bold text-xl" data-id="element-23">
                  Resultados Impecables
                </p>
                <p className="text-white/80 text-sm" data-id="element-24">
                  Proyecto reciente en Central Florida
                </p>
              </div>
            </div>

            {/* Floating Badge */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} className="absolute -bottom-8 -right-8 bg-white p-6 rounded-xl shadow-xl hidden md:block max-w-xs border border-gray-100" data-id="element-25">
              <div className="flex items-center gap-4 mb-2" data-id="element-26">
                <div className="bg-pool-100 p-3 rounded-full text-pool-600" data-id="element-27">
                  <Award size={24} data-id="element-28" />
                </div>
                <div data-id="element-29">
                  <h4 className="font-bold text-gray-900" data-id="element-30">CPO Certified</h4>
                  <p className="text-sm text-gray-500" data-id="element-31">Expertos calificados</p>
                </div>
              </div>
            </motion.div>
          </motion.div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-32">
            <h2 className="text-pool-600 font-semibold tracking-wider uppercase text-sm mb-2" data-id="element-33">
              Sobre Nosotros
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6 leading-tight" data-id="element-34">
              Transformando Piscinas en Central Florida con Excelencia
            </h3>

            <p className="text-gray-600 mb-6 text-lg leading-relaxed" data-id="element-35">
              En <strong data-id="element-36">Innova Pools & Systems</strong>, no solo reparamos
              piscinas; creamos oasis residenciales. Con años de experiencia
              sirviendo a la comunidad de Central Florida, entendemos la
              importancia de tener una piscina segura, hermosa y funcional
              durante todo el año.
            </p>

            <p className="text-gray-600 mb-8 text-lg leading-relaxed" data-id="element-37">
              Nuestro compromiso es la calidad y la transparencia. Por eso,
              acompañamos cada remodelación con una oferta inigualable para
              asegurar que su inversión se mantenga perfecta desde el primer
              día.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8" data-id="element-38">
              <div className="flex items-start gap-3" data-id="element-39">
                <ShieldCheck className="text-gold-500 mt-1 flex-shrink-0" size={24} data-id="element-40" />
                <div data-id="element-41">
                  <h4 className="font-bold text-navy-900" data-id="element-42">Fully Insured</h4>
                  <p className="text-sm text-gray-500" data-id="element-43">
                    Tranquilidad total en cada proyecto.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-44">
                <Droplets className="text-pool-500 mt-1 flex-shrink-0" size={24} data-id="element-45" />
                <div data-id="element-46">
                  <h4 className="font-bold text-navy-900" data-id="element-47">
                    Crystal Clear Water
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-48">
                    Garantía de agua cristalina y balanceada.
                  </p>
                </div>
              </div>
            </div>

            <a href="#contacto" className="inline-flex items-center justify-center bg-navy-900 hover:bg-navy-800 text-white font-semibold py-3 px-8 rounded-full transition-colors" data-id="element-49">
              Conozca a Nuestro Equipo
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}